import { useTranslation } from 'react-i18next';
import { Button, Stepper } from '@/components/common';
import { WizardHeader } from '@/components/layout';
import type { OnboardingFlow } from '@/hooks/useOnboardingFlow';

export function OnboardingWizardHeader({
  flow,
  onSkip,
}: {
  flow: OnboardingFlow;
  onSkip?: () => void;
}) {
  const { t } = useTranslation('common');

  return (
    <WizardHeader
      onBack={flow.back}
      centerContent={
        <Stepper progress={flow.progress} step={flow.step} totalSteps={flow.totalSteps} />
      }
      right={
        onSkip && (
          <Button
            type="button"
            variant="outline"
            color="gray"
            highContrast
            radius="full"
            size="sm"
            onClick={onSkip}
          >
            {t('actions.skip')}
          </Button>
        )
      }
    />
  );
}
